import { CategoryFilter } from "@/components/molecules/modernise-with-ai/CategoryFilter";
import { ToolsGrid } from "@/components/molecules/modernise-with-ai/ToolsGrid";

interface ModernisationToolsSectionProps {
  categories: string[];
  selectedCategory: string;
  onCategoryChange: (category: string) => void;
  selectedTools: any[];
  onToolToggle: (tools: any[]) => void;
}

export const ModernisationToolsSection: React.FC<
  ModernisationToolsSectionProps
> = ({
  categories,
  selectedCategory,
  onCategoryChange,
  selectedTools,
  onToolToggle,
}) => (
  <>
    <CategoryFilter
      categories={categories}
      selectedCategory={selectedCategory}
      onCategoryChange={onCategoryChange}
    />

    <ToolsGrid
      selectedCategory={selectedCategory}
      selectedTools={selectedTools}
      onToolToggle={onToolToggle}
    />
  </>
);
